module.exports = __webpack_public_path__ + "img/prof-dr-hab-Jacek-Jezierski.b9f129bb.jpg";